function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "flaslight");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Website",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Products-Copy",
  transform: "translate(-986.000000, -1824.000000)",
  fill: "#343E40",
  stroke: "#7CA1A6"
}, /*#__PURE__*/React.createElement("g", {
  id: "flaslight",
  transform: "translate(987.686792, 1825.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M79,63.1936597 L13,63.1936597 C9.6862915,63.1936597 7,65.8747254 7,69.1819875 L7,93.1352988 C7,96.442561 9.6862915,99.1236267 13,99.1236267 L79,99.1236267 L82.0225,101.135331 C90.11125,106.51734 99.38875,109.681797 109,110.658643 L109,51.6586432 C99.38875,52.6354891 90.11125,55.7999461 82.0225,61.1819558 L79,63.1936597 Z M61.25,86.7256305 L55.25,86.7256305 C51.9362915,86.7256305 49.25,84.039339 49.25,80.7256305 C49.25,77.411922 51.9362915,74.7256305 55.25,74.7256305 L61.25,74.7256305 C64.5637085,74.7256305 67.25,77.411922 67.25,80.7256305 C67.25,84.039339 64.5637085,86.7256305 61.25,86.7256305 Z M120.515372,50.878843 L114.515372,50.878843 L114.515372,110.878843 L120.515372,110.878843 C123.82908,110.878843 126.515372,108.192551 126.515372,104.878843 L126.515372,56.878843 C126.515372,53.5651345 123.82908,50.878843 120.515372,50.878843 Z",
  id: "flashlight",
  fillRule: "nonzero",
  transform: "translate(66.757686, 80.878843) rotate(-30.000000) translate(-66.757686, -80.878843) "
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  transform: "translate(141.313208, 36.500000) rotate(-30.000000) translate(-141.313208, -36.500000) ",
  x: 122.313208,
  y: 34,
  width: 38,
  height: 5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy",
  transform: "translate(152.313208, 58.500000) rotate(-15.000000) translate(-152.313208, -58.500000) ",
  x: 133.313208,
  y: 56,
  width: 38,
  height: 5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-2",
  transform: "translate(128.313208, 15.500000) rotate(-45.000000) translate(-128.313208, -15.500000) ",
  x: 109.313208,
  y: 13,
  width: 38,
  height: 5
}))));

var SvgScooterFlashlight = function SvgScooterFlashlight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "174px",
    height: "139px",
    viewBox: "0 0 174 139",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScooterFlashlight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scooter-flashlight.dff7a016.svg";
export { ForwardRef as ReactComponent };